import createVueApp from '@/common/createApp'

Styxie.Initializers.AdminActivity = {
  index: async(props) => {
    const { default: ActivityIndex } = await import('@/vue_widgets/admin/activity/index.vue')
    createVueApp(ActivityIndex, { props })
  }
}
